import React, { FC } from "react";
import { CalendarEntryUpdate, isSameRow } from "./DropAreaHelper";
import AddIcon from "@material-ui/icons/Add";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import moment from "moment";
import { DropArea } from "./types/DropArea";
import { DraggedItem } from "./types/DraggedItem";

interface Props {
	dropArea: DropArea;
	draggedItem: DraggedItem | null;
	calendarEntryUpdate?: CalendarEntryUpdate;
}

const DropAreaIconView: FC<Props> = (props) => {
	if (isSameRow(props.draggedItem?.calendarEntry, props.calendarEntryUpdate)) {
		const startTime = props.draggedItem?.calendarEntry.startTime
			? moment.unix(props.draggedItem?.calendarEntry.startTime)
			: undefined;

		if (props.dropArea.start.isBefore(startTime)) {
			return <ArrowBackIcon />;
		} else {
			return <ArrowForwardIcon />;
		}
	} else {
		return <AddIcon />;
	}
};

export default DropAreaIconView;
